export function isMobile() {
  return window.matchMedia('(max-width: 991px)').matches
}

export function createSlider({ wrapper, prevArrow, nextArrow, options }) {
  let slider = null

  if ($(wrapper).length) {
    const sliderOptions = {
      ...options,
      accessibility: true,
      arrows: true,
      prevArrow,
      nextArrow,
    }

    slider = $(wrapper).slick(sliderOptions)
  }

  return slider
}



// WEBPACK FOOTER //
// ./scripts/func/common.js